// src/components/maps/MapView.vue
<script setup>
import { onMounted, computed } from 'vue'
import { useMapStore } from '@/stores/map'
import { useDataStore } from '@/stores/data'
import GeoCoder from './GeoCoder.vue'

const mapStore = useMapStore()
const dataStore = useDataStore()

// computed property for var joinableTrips = dataStore.currentJourney.trips.filter((t) => t.join)

const hasJoinableTrips = computed(() => {
	if (!dataStore.currentJourney?.trips?.length === 0) return false
	else return dataStore.currentJourney?.trips?.filter((t) => t.join).length > 0
})

onMounted(() => {
	mapStore.initMap()
})
</script>

<template>
	<div id="map" class="w-full h-screen" :class="{ joinmode: hasJoinableTrips }"></div>
	<GeoCoder />
	<div class="mapLogos">
		<div class="logo" style="width: 120vw"><img style="height: 17px" src="/src/assets/kogenta_logo_black.svg" /></div>
		<div class="logo" style="width: 116.5vw"><img style="height: 13px" src="/src/assets/opinion_logo_black.svg" /></div>
	</div>
</template>

<style>
.mapLogos {
	position: absolute;
	top: 0px;
	left: 0;
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	width: 100%;
	align-items: flex-start;
}

.mapLogos .logo {
	filter: opacity(0.5);
	backdrop-filter: blur(1rem);
	max-width: 85px;
	padding: 0.75rem;
	padding-top: 0.25rem;
	padding-bottom: 0.25rem;
	margin: 0.25rem;
	border-radius: 1rem;
}

.mapLogos .logo img {
	opacity: 0.8;
}

.mapboxgl-canvas {
	width: 100% !important;
	height: 100% !important;
}

.mapboxgl-ctrl-top-right {
	top: 70px;
	right: 12px;
}

.mapboxgl-ctrl-group {
	background-color: transparent !important;
	box-shadow: none !important;
}

.mapboxgl-popup-close-button,
a.mapboxgl-ctrl-logo,
.mapboxgl-ctrl.mapboxgl-ctrl-attrib {
	display: none;
}

.mapboxgl-user-location,
.mapboxgl-user-location-accuracy-circle {
	pointer-events: none;
}

#map.joinmode .marker:not(.join) {
	display: none;
}
</style>
